import {useEffect} from 'react';
import siteConfig from '../config/siteConfig';

const CONSENT_KEY = 'ycm_cookie_consent';

function initAnalytics() {
  if (window.__ycmAnalyticsInit) return;
  window.__ycmAnalyticsInit = true;

  const {ga4Id, linkedInPartnerId, clarityId} = siteConfig.analytics;

  // GA4
  if (ga4Id) {
    const s = document.createElement('script');
    s.src = `https://www.googletagmanager.com/gtag/js?id=${ga4Id}`;
    s.async = true;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function() { window.dataLayer.push(arguments); };
    window.gtag('js', new Date());
    window.gtag('config', ga4Id);
  }

  // Microsoft Clarity
  if (clarityId) {
    (function(c, l, a, r, i, t, y) {
      c[a] = c[a] || function() { (c[a].q = c[a].q || []).push(arguments); };
      t = l.createElement(r); t.async = 1; t.src = 'https://www.clarity.ms/tag/' + i;
      y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
    })(window, document, 'clarity', 'script', clarityId);
  }

  // LinkedIn Insight Tag
  if (linkedInPartnerId) {
    window._linkedin_partner_id = linkedInPartnerId;
    window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
    window._linkedin_data_partner_ids.push(linkedInPartnerId);
    const s = document.createElement('script');
    s.type = 'text/javascript';
    s.async = true;
    s.src = 'https://snap.licdn.com/li.lms-analytics/insight.min.js';
    document.head.appendChild(s);
  }
}

export function useAnalytics() {
  useEffect(() => {
    if (!siteConfig.features.analytics) return;

    // Initialize immediately if consent was already given in a previous session
    if (localStorage.getItem(CONSENT_KEY) === 'accepted') {
      initAnalytics();
    }

    // Initialize when user accepts consent in the current session
    window.addEventListener('ycm:consent:accepted', initAnalytics);
    return () => window.removeEventListener('ycm:consent:accepted', initAnalytics);
  }, []);
}
